/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.1.4 (2019-12-11)
 */
import tinymce from "tinymce"
;(function() {
  "use strict"

  var global = tinymce.util.Tools.resolve("tinymce.PluginManager")

  var global$1 = tinymce.util.Tools.resolve("tinymce.util.Tools")

  var getPreviewDialogWidth = function(editor) {
    return parseInt(editor.getParam("plugin_preview_width", "650"), 10)
  }
  var getPreviewDialogHeight = function(editor) {
    return parseInt(editor.getParam("plugin_preview_height", "500"), 10)
  }
  var getContentStyle = function(editor) {
    return editor.getParam("content_style", "")
  }
  var shouldUseContentCssCors = function(editor) {
    return editor.getParam("content_css_cors", false, "boolean")
  }
  var Settings = {
    getPreviewDialogWidth: getPreviewDialogWidth,
    getPreviewDialogHeight: getPreviewDialogHeight,
    getContentStyle: getContentStyle,
    shouldUseContentCssCors: shouldUseContentCssCors
  }

  var global$2 = tinymce.util.Tools.resolve("tinymce.Env")

  var getPreviewHtml = function(editor) {
    var headHtml = ""
    var encode = editor.dom.encode
    var contentStyle = Settings.getContentStyle(editor)
    headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">'
    if (contentStyle) {
      headHtml += '<style type="text/css">' + contentStyle + "</style>"
    }
    var cors = Settings.shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : ""
    global$1.each(editor.contentCSS, function(url) {
      headHtml +=
        '<link type="text/css" rel="stylesheet" href="' +
        encode(editor.documentBaseURI.toAbsolute(url)) +
        '"' +
        cors +
        ">"
    })
    var bodyId = editor.settings.body_id || "tinymce"
    if (bodyId.indexOf("=") !== -1) {
      bodyId = editor.getParam("body_id", "", "hash")
      bodyId = bodyId[editor.id] || bodyId
    }
    var bodyClass = editor.settings.body_class || ""
    if (bodyClass.indexOf("=") !== -1) {
      bodyClass = editor.getParam("body_class", "", "hash")
      bodyClass = bodyClass[editor.id] || ""
    }
    var isMetaKeyPressed = global$2.mac ? "e.metaKey" : "e.ctrlKey && !e.altKey"
    var preventClicksOnLinksScript =
      '<script>\n    // 辅助判断图片是否加载完\n    var imgs = document.querySelectorAll("img");\n    var totalCount = imgs.length, loadedCount = 0;\n    window.parent._tinyImagesLoading = imgs.length > 0\n    for (let i = 0; i < imgs.length; i++) {\n        var img = imgs[i];\n        img.addEventListener("load", function () {\n            loadedCount++;\n            checkImgLoaded()\n        })\n        if (img.complete) loadedCount++;\n    }\n    checkImgLoaded()\n\n    function checkImgLoaded() {\n        if (loadedCount >= totalCount) window.parent._tinyImagesLoading = false\n    }\n\n    // 阻止点击a标签跳转\n    ' +
      'document.addEventListener && document.addEventListener("click", function (e) {\n        ' +
      "for (var elm = e.target; elm; elm = elm.parentNode) {\n            " +
      'if (elm.nodeName === "A" && !(' +
      isMetaKeyPressed +
      ")) {\n                " +
      "e.preventDefault();\n            " +
      "}\n        " +
      "}\n    " +
      "}, false);\n" +
      "</script> "
    var directionality = editor.getBody().dir
    var dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : ""
    var previewHtml =
      "<!DOCTYPE html>" +
      "<html>" +
      "<head>" +
      headHtml +
      "</head>" +
      '<body id="' +
      encode(bodyId) +
      '" class="mce-content-body ' +
      encode(bodyClass) +
      '"' +
      dirAttr +
      ">" +
      editor.getContent() +
      preventClicksOnLinksScript +
      "</body>" +
      "</html>"
    return previewHtml
  }
  var IframeContent = { getPreviewHtml: getPreviewHtml }

  var open = function(editor) {
    var content = IframeContent.getPreviewHtml(editor)
    var dataApi = editor.windowManager.open({
      title: "Preview",
      size: "large",
      body: {
        type: "panel",
        items: [
          {
            name: "preview",
            type: "iframe",
            sandboxed: true
          }
        ]
      },
      buttons: [
        {
          type: "submit",
          name: "打印",
          text: "打印",
          primary: true
        },
        {
          type: "cancel",
          name: "close",
          text: "Close",
          primary: true
        }
      ],
      initialData: { preview: content },
      onSubmit: function(api) {
        if (window._tinyImagesLoading) {
          alert("请等待图片加载完成后点击打印")
          return
        }
        api.close()
        return editor.execCommand("mcePrint")
      }
    })
    dataApi.focus("close")
  }

  var register = function(editor) {
    editor.addCommand("mcePreview", function() {
      open(editor)
    })
  }
  var Commands = { register: register }

  var register$1 = function(editor) {
    editor.ui.registry.addButton("preview", {
      icon: "preview",
      tooltip: "Preview",
      onAction: function() {
        return editor.execCommand("mcePreview")
      }
    })
    editor.ui.registry.addMenuItem("preview", {
      icon: "preview",
      text: "Preview",
      onAction: function() {
        return editor.execCommand("mcePreview")
      }
    })
  }
  var Buttons = { register: register$1 }

  function Plugin() {
    global.add("preview", function(editor) {
      Commands.register(editor)
      Buttons.register(editor)
    })
  }

  Plugin()
})()
